export class DTFilter { }



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/common/dt-filter.ts